
















import Vue from 'vue'

import { WidgetService } from '../widget/WidgetService'
import { MenuMixin } from './MenuMixin'

export default Vue.extend({
  mixins: [MenuMixin],
  computed: {
    availableWidgets() {
      return WidgetService.getWidgetSpecifications()
    }
  },
  methods: {
    addWidget(widgetType) {
      this.$emit('widget-add-new', widgetType)
      this.hideDialog()
    }
  }
})
